import React, { useState, useEffect, useCallback } from 'react';
import { FaBell, FaUserCircle, FaBars, FaTimes} from 'react-icons/fa';
import {MdOutlineSos} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import UserModal from '../modal/UserModal';
import NotificationsModal from '../modal/NotificationsModal';
import SOSModal from '../modal/SOSModal';
import FrontendNotificationsAPI from '../api/frontendNotifications';
import NavbarLogo from '../assets/navbar_logo.png';
import '../css/Navbar.css'; 

const Navbar = ({ isSidebarClosed, setIsSidebarClosed }) => {
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
  const [sosModalOpen, setSOSModalOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  const loadUnreadCount = useCallback(async () => {
    try {
      const response = await FrontendNotificationsAPI.getStats();
      
      const unreadCount = response.unread || 0;
      setUnreadCount(unreadCount);
    } catch (error) {
      console.warn('⚠️ Notification stats not available:', error.message);
      // Don't reset the count to 0 if there's an error, keep the current state
    }
  }, []);

  const handleUnreadCountChange = useCallback((count) => {
    setUnreadCount(count);
  }, []);

  useEffect(() => {
    loadUnreadCount();
    
    const interval = setInterval(loadUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [loadUnreadCount]);

  return (
    <nav className="navbar">
      <ul className="navbar-icons navbar-icons-left">
        <li>
          <button className="navbar-sidebar-toggle" onClick={() => setIsSidebarClosed(v => !v)}>
            {isSidebarClosed ? <FaBars /> : <FaTimes />}
          </button>
        </li>
        <li>
          <button className="navbar-sos-button" onClick={() => setSOSModalOpen(true)} title="SOS - Segítségkérés">
            <MdOutlineSos />
          </button>
        </li>
      </ul>
      <div className="navbar-center-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
        <img src={NavbarLogo} alt="Logo" className="navbar-logo" />
      </div>
      <ul className="navbar-icons navbar-icons-right">
        <li className="navbar-icon-bell" onClick={() => setNotificationsModalOpen(true)}>
          <FaBell />
          {unreadCount > 0 && (
            <span className="navbar-bell-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </li>
        <li>
          <span style={{ cursor: 'pointer', marginTop: '6px' }} onClick={() => setUserModalOpen(v => !v)}>
            <FaUserCircle />
          </span>
        </li>
      </ul>
      <UserModal open={userModalOpen} onClose={() => setUserModalOpen(false)} />
      <NotificationsModal
        open={notificationsModalOpen}
        onClose={() => setNotificationsModalOpen(false)}
        onUnreadCountChange={handleUnreadCountChange}
      />
      <SOSModal
        open={sosModalOpen}
        onClose={() => setSOSModalOpen(false)}
      />
    </nav>
  );
};

export default Navbar; 